(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const openBtn = document.querySelector('[data-search-open]');
    const modal = document.querySelector('[data-search-modal]');
    if (openBtn && modal) {
      openBtn.addEventListener('click', () => {
        modal.hidden = false;
        const input = modal.querySelector('input[type="search"]');
        if (input) input.focus();
      });
      modal.querySelectorAll('[data-search-close]').forEach((el) =>
        el.addEventListener('click', () => (modal.hidden = true))
      );
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') modal.hidden = true;
      });
    }
    document.querySelectorAll('[data-cart-toggle]').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (document.body.getAttribute('data-cart-type') === 'drawer') {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
